module.exports = __webpack_public_path__ + "3301863db6821e252c16e3cb1798a7d2.gif";